var _rect, _rect2, _rect3, _path, _path2, _line, _line2, _line3, _line4, _path3, _line5, _line6, _path4, _path5, _rect4, _path6, _path7, _ellipse, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReviewIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 38,
    viewBox: "0 0 29 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 4.84082,
    width: 21.9909,
    height: 29.4091,
    rx: 1.25,
    fill: "white",
    stroke: "#717070",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.94531,
    y: 2.85449,
    width: 13.6,
    height: 3.70909,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.93164,
    y: 3.60449,
    width: 9.62727,
    height: 2.20909,
    rx: 1.10455,
    fill: "white",
    stroke: "#717070",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7452 1C10.2616 1 10.3028 2.64848 10.5088 3.47273H12.9815C13.1876 2.64848 13.2288 1 11.7452 1Z",
    stroke: "#717070",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.70898 11.8179L4.94535 12.7452L7.41808 10.2725",
    stroke: "#717070"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8.6543,
    y1: 11.0088,
    x2: 19.7816,
    y2: 11.0088,
    stroke: "#717070"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 8.6543,
    y1: 13.4814,
    x2: 19.7816,
    y2: 13.4814,
    stroke: "#717070"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 8.6543,
    y1: 18.4272,
    x2: 19.7816,
    y2: 18.4272,
    stroke: "#717070"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 8.6543,
    y1: 20.8999,
    x2: 19.7816,
    y2: 20.8999,
    stroke: "#717070"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.70898 26.6548L4.94535 27.5821L7.41808 25.1094",
    stroke: "#717070"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 8.6543,
    y1: 25.8457,
    x2: 19.7816,
    y2: 25.8457,
    stroke: "#717070"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 8.6543,
    y1: 28.3184,
    x2: 19.7816,
    y2: 28.3184,
    stroke: "#717070"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00054 18.3599L7.00038 21.3599",
    stroke: "#717070"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 21.3599L6.99994 18.3599",
    stroke: "#717070"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 22.7014,
    width: 4,
    height: 16.2824,
    rx: 2,
    transform: "rotate(-25.1718 18 22.7014)",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1357 26.4021C17.0076 26.4061 15.8923 26.1852 14.8507 25.7514C13.8636 25.34 12.9636 24.7374 12.1988 23.9756C11.4424 23.2296 10.8379 22.3348 10.4199 21.3423C9.99635 20.3296 9.78414 19.2335 9.79693 18.1248C9.80973 17.0161 10.0472 15.9194 10.4942 14.9056C10.9344 13.9123 11.5586 13.016 12.3312 12.2679C13.1137 11.5041 14.0276 10.8993 15.0242 10.4855C17.1481 9.61 19.5056 9.60709 21.6093 10.4774C22.5964 10.8887 23.4964 11.4913 24.2613 12.2532C25.0166 12.9994 25.6202 13.8942 26.0375 14.8864C26.461 15.8992 26.6732 16.9953 26.6604 18.104C26.6476 19.2127 26.4101 20.3093 25.9632 21.3232C25.523 22.3164 24.8988 23.2128 24.1262 23.9609C23.3437 24.7246 22.4298 25.3295 21.4331 25.7433C20.3823 26.179 19.2628 26.4027 18.1357 26.4021Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3353 24.5784C22.1311 24.172 22.8364 23.6037 23.4129 22.9057L23.4131 22.9055C23.9613 22.2411 24.3777 21.4679 24.6417 20.6283C24.9054 19.8004 25.0082 18.9197 24.9461 18.0367L24.946 18.0357C24.8808 17.1324 24.6376 16.245 24.2327 15.4302C23.8279 14.6154 23.2697 13.8896 22.593 13.2998L22.5923 13.2992C21.9299 12.7241 21.1715 12.2851 20.3593 12.009C19.5376 11.7262 18.678 11.6075 17.8263 11.6611L17.8263 11.6611L17.825 11.6611C16.0165 11.7798 14.3549 12.632 13.187 14.0399L13.187 14.0399L13.1861 14.0409C12.6379 14.7053 12.2215 15.4784 11.9575 16.3181C11.6938 17.146 11.591 18.0267 11.6531 18.9097L11.6531 18.9097L11.6531 18.9106C11.7184 19.814 11.9616 20.7014 12.3665 21.5162C12.7713 22.331 13.3295 23.0568 14.0062 23.6466L14.0062 23.6466L14.0071 23.6474C14.6701 24.2223 15.4291 24.6609 16.2418 24.9365C17.0635 25.2193 17.923 25.338 18.7747 25.2844L18.7748 25.2844C19.6708 25.2278 20.5404 24.9884 21.3353 24.5784ZM21.3353 24.5784C21.335 24.5786 21.3347 24.5787 21.3344 24.5789L21.1127 24.1307L21.3363 24.5779C21.336 24.5781 21.3356 24.5782 21.3353 24.5784Z",
    fill: "white",
    stroke: "#717070"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.84009,
    ry: 0.763499,
    transform: "matrix(0.891095 -0.453817 0.442446 0.896795 21.5693 25.6143)",
    fill: "#717070"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3833 26.4518C21.3612 26.4024 21.3478 26.3494 21.3438 26.2953C21.3128 25.8801 21.7955 25.6317 22.1066 25.9027C22.1472 25.938 22.1813 25.9803 22.2074 26.0277L27.1275 34.9575C27.3695 35.3969 27.1994 35.9543 26.7531 36.184C26.3068 36.4137 25.7639 36.2232 25.5584 35.765L21.3833 26.4518Z",
    fill: "#717070"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2242 32.0926C22.917 31.4743 23.1659 30.7178 23.7802 30.4027V30.4027C24.3945 30.0877 25.1414 30.3335 25.4486 30.9517L27.3306 34.7396C27.6378 35.3579 27.3889 36.1145 26.7746 36.4295V36.4295C26.1603 36.7445 25.4134 36.4988 25.1062 35.8805L23.2242 32.0926Z",
    fill: "#717070"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewIcon);
export default __webpack_public_path__ + "static/media/review-icon.5055e566878434f7021367830fe4872a.svg";
export { ForwardRef as ReactComponent };